import "core-js/modules/es.array.push.js";
import { getClientAppData } from "@/js/http/auth";
import { request } from "@/js/http/http_request";
import { tenantType } from "@/js/lists.ts";
export default {
  name: "resetPassword",
  data: function data() {
    return {
      clientAppData: null,
      enter: true,
      tenant_type: ""
    };
  },
  created: function created() {
    this.clientAppData = getClientAppData(this);
    var _this = this;
    request("/v1/tenants/informations", "post", _this.clientAppData, false, "cap").then(function (response) {
      _this.tenant_type = response.data.tenant_type;
    });
  },
  methods: {
    enterWebsite: function enterWebsite() {
      this.enter = false;
    },
    afterLeave: function afterLeave(el) {
      var _this$$route$query, _this$$route$query2;
      var query = {};
      if ((_this$$route$query = this.$route.query) !== null && _this$$route$query !== void 0 && _this$$route$query.utm_source) query.utm_source = (_this$$route$query2 = this.$route.query) === null || _this$$route$query2 === void 0 ? void 0 : _this$$route$query2.utm_source;
      if (this.tenant_type == tenantType.OWNER) {
        this.$router.push({
          name: "home",
          query: query
        });
      } else {
        this.$router.push({
          name: "login",
          query: query
        });
      }
    }
  }
};